<template lang="pug">
.page-main-title(v-if='pageTitle')
  .line1.text-stroke(:data-text="pageTitle.preTitle") {{pageTitle.preTitle}}
  .line2
    .text-stroke.day-num(
      :data-text="pageTitle.highlight"
      style="color: red"
    ) {{pageTitle.highlight}}
    .text-stroke(:data-text="pageTitle.postTitle") {{pageTitle.postTitle}}
</template>

<script>
export default {
  name: 'PageMainTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    pageTitle() {
      // 后端返回的标题大概是这种形式：“哈啰送你|{30天}单车补贴”
      // 竖线前面的是第一行标题，竖线后面的是第二行标题
      // 花括号里面的内容是红色高亮显示的
      try {
        const arr = this.title.split('|');
        const preTitle = arr[0];
        const highlight = arr[1].match(/\{(.*)\}/)[1];
        const postTitle = arr[1].replace(`{${highlight}}`, '');
        return {
          preTitle,
          highlight,
          postTitle,
        };
      } catch (error) {
        return null;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-main-title {
  position: absolute;
  left: 0.3rem;
  top: 1.36rem;
  font-size: 0.35rem;
  font-weight: 700;

  .line2 {
    display: flex;
    align-items: baseline;
    margin-top: -0.12rem;
  }

  .text-stroke {
    position: relative;
    color: transparent;
    font-weight: 400;
    font-family: 'MFYuanHei', sans-serif;
    font-style: italic;

    &::after {
      content: attr(data-text);
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 1;
      color: #000;
    }

    &::before {
      content: attr(data-text);
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 0;
      -webkit-text-stroke: 10px #fff;
      color: transparent;
    }

    &.day-num {
      &::after {
        color: #fd1d37;
      }

      &::before {
        -webkit-text-stroke: 10px #fff;
      }
    }
  }
}
</style>
